/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExportedTaskOutputRubricAnyOf } from './exportedTaskOutputRubricAnyOf';

export type ExportedTaskOutputRubric = ExportedTaskOutputRubricAnyOf | null;
